module fdm {

    let app = angular.module('fdm')
        .constant('apiSettings', <dg.restfulApi.ApiSettings>{
            version: 1
        }).config(($compileProvider: ng.ICompileProvider) => {
            $compileProvider.debugInfoEnabled(true);

            $compileProvider.commentDirectivesEnabled(false);
            $compileProvider.cssClassDirectivesEnabled(false);
        })
        //Translation configuration
        //    .config([<any> '$translateProvider', ($translateProvider: ng.translate.ITranslateProvider) => {
        //    // Register a loader for the static files
        //    // So, the module will search missing translation tables under the specified urls.
        //    // Those urls are [prefix][langKey][suffix].
        //    $translateProvider.useStaticFilesLoader({w
        //        prefix: 'l10n/',
        //        suffix: '.json'
        //    });

        //    // Tell the module what language to use by default
        //    $translateProvider.preferredLanguage('en');

        //    // Tell the module to store the language in the local storage
        //    $translateProvider.useLocalStorage();
        //}])
        //HTTP Headers configuration
        .config(($httpProvider: ng.IHttpProvider) => {
            //Fix for .Net.isAjax - https://github.com/angular/angular.js/commit/3a75b1124d062f64093a90b26630938558909e8d
            $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
        })



        //Adal config
        // .config(($httpProvider: ng.IHttpProvider, adalAuthenticationServiceProvider: any) => {

        //     let adalConfig: any = {
        //         //When tenant is not specified, the app is multitenant and "common" is used
        //         //tenant: 'iteraflow1124.onmicrosoft.com',
        //         clientId: dg.clients.ApplicationInfoService.webAppClientId,
        //         cacheLocation: 'localStorage',
        //         //extraQueryParameter: 'nux=1'
        //         endpoints: {},
        //         anonymousEndpoints: [],
        //         requireADLogin: true
        //     }

        //     //applicationInfoServiceProvider.setAdalConfig(adalConfig);
        //     //adalConfig.endpoints[clientInfo.office365TenantUrl] = clientInfo.office365TenantUrl;

        //     adalAuthenticationServiceProvider.init(adalConfig, $httpProvider);

        //     //$httpProvider.interceptors.push('removeAuthHeaderForTemplatesInterceptor');
        // })

        //MSAL config
        .config(['msalAuthenticationServiceProvider', '$httpProvider', function (msalProvider, $httpProvider) {
            msalProvider.init({                
                clientID: dg.clients.ApplicationInfoService.webAppClientId,//applicationConfig.clientID,
                tokenReceivedCallback: function (errorDesc, token, error, tokenType) {},
                optionalParams: {
                    redirectUri: window.location.protocol + '//' + window.location.host
                }
            }, $httpProvider);
        }])
        .config((DefaultListQueryOptionsProvider: dg.actions.DefaultListQueryOptionsProvider) => {
            //DefaultListQueryOptionsProvider.setActionClolumnEnabled(true);
        })

    app.run(["$locale", ($locale) => {
        $locale.NUMBER_FORMATS.GROUP_SEP = " ";
    }]);
}